import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { financeApi, type FinanceDetail as Detail } from "../../api/finance";
import type { ApiError } from "../../api/client";
import { FinanceDetail } from "./FinanceDetail";
import { FinanceFilters, type FiltersValue } from "./FinanceFilters";
import { presetRange } from "./usePeriod";

export default function FinanceMePage() {
  const { t } = useTranslation();
  const [data, setData] = useState<Detail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const init = useMemo<FiltersValue>(() => ({ preset: "ytd", ...presetRange("ytd") }), []);
  const [filters, setFilters] = useState<FiltersValue>(init);

  useEffect(() => {
    setData(null);
    financeApi.me({ from: filters.from, to: filters.to })
      .then(setData)
      .catch((e: ApiError) => setError(e.message));
  }, [filters.from, filters.to]);

  const onChange = (v: FiltersValue) => {
    const range = v.preset === "custom" ? { from: v.from, to: v.to } : presetRange(v.preset);
    setFilters({ ...v, ...range });
  };

  return (
    <div className="fadein" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="page-head">
        <div>
          <h1>{t("finance.title", "Finance")}</h1>
          <div className="sub">{t("finance.subtitle.me", "Your account, invoices and payments")}</div>
        </div>
        <div className="page-actions">
          <FinanceFilters value={filters} markets={[]} countries={[]} onChange={onChange} />
        </div>
      </div>
      {error && <div className="empty">{error}</div>}
      {data ? <FinanceDetail data={data} /> : <p style={{ color: "var(--ink-3)", padding: 20 }}>Loading…</p>}
    </div>
  );
}
